export default __webpack_public_path__ + "static/media/upload-icon.4e5aba8b.svg";